module.exports = __webpack_public_path__ + "img/joodskindermonument_wolkvoorin_600x600px.3928a5f2.png";